import { gql } from '@apollo/client'
import { ArrowRightIcon, BodyText, Button, Heading } from '@farol-ds/react'

import { BenefitsList } from '../benefits-list'
import { DoctrineUnloggedLockContent_OfferLockDataFragment } from './__generated__/doctrine-unlogged-lock-content.graphql'
import styles from './doctrine-unlogged-lock-content.module.scss'

export interface DoctrineUnloggedLockContentProps {
  offerLockData: DoctrineUnloggedLockContent_OfferLockDataFragment
}

export function DoctrineUnloggedLockContent({ offerLockData }: DoctrineUnloggedLockContentProps) {
  const { body, header } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const {
    cards: [card],
  } = body || {}

  return (
    <>
      <div className={styles.header}>
        <Heading size="lg">{title}</Heading>
        <BodyText size="md">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>

      <div className={styles.card}>
        <BenefitsList offerLockCard={card} />

        <div className={styles.buttons}>
          {card.buttons.map((button, index) => (
            <Button
              key={index}
              kind={button.kind || 'primary'}
              rightIcon={index === card.buttons.length - 1 && <ArrowRightIcon />}
              asChild={!!button.url}
            >
              {button.url ? (
                <a href={button.url} target={index > 0 ? '_blank' : ''} rel="noopener noreferrer">
                  {button.label}
                </a>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
    </>
  )
}

DoctrineUnloggedLockContent.fragments = {
  offerLockData: gql`
    fragment DoctrineUnloggedLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          buttons {
            label
            kind
            url
          }
          ...BenefitsList_offerLockCard
        }
      }
    }

    ${BenefitsList.fragments.offerLockCard}
  `,
}
